module.exports = __webpack_public_path__ + "static/on-a-table-58f6bd0673524d8ec8a2f99bc81b0cf0.png";